import { client } from './client';

export const missionApi = {
  getTicketInfo: (ticket_id) => client.get('get_ticket_info', { params: { ticket_id } }),
  getDepartmentEmployeeStatus: () => client.get('manager_get_department_employee_status'),
  // backend (getCompanyLocation, views.py) reads request.GET.get('company_name'),
  // not company_id - this was never actually called anywhere, so the wrong
  // param name was silently dead until now.
  getCompanyLocation: (company_name) => client.get('get_company_location', { params: { company_name } }),
  getEmployeeLastLocation: (employee_id) => client.get('get_employee_last_location', { params: { employee_id } }),
  getLocationPoint: (params) => client.get('get_location_point', { params }),
  addMission: (params) => client.get('add_mission', { params }),
  getMissionTicketInfo: (ticket_id) => client.get('get_mission_ticket_info', { params: { ticket_id } }),
  getMyMissions: () => client.get('get_my_missions'),
  getCurrentMap: () => client.get('get_current_map'),
  getShortestPath: (params) => client.get('get_shortest_path', { params }),
  getApprovalStatus: (ticket_id) => client.get('get_mission_approval_status', { params: { ticket_id } }),
  verifyOtp: (params) => client.get('verify_mission_otp', { params }),
  resendOtp: (mission_id) => client.get('resend_mission_otp', { params: { mission_id } }),
};
